import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/BuyOnlinePickupInstore/GET';

export const BUY_ONLINE_PICKUP_INSTORE_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const BUY_ONLINE_PICKUP_INSTORE_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
